'use client'
import NavigateLeftIcon from '@/app/icons/navigate-left'
import NavigateRightIcon from '@/app/icons/navigate-right'
import { relativeUrl } from '@/util/url'
import { IGif } from '@giphy/js-types'
import { useRouter } from 'next/navigation'
import { useRelatedGifPagination } from './use-related-pagination'
type Props = { gif: IGif }
const DesktopPagination = ({ gif }: Props) => {
    const { next, prev } = useRelatedGifPagination(gif)
    const router = useRouter()
    const prevUrl = prev?.url
    const nextUrl = next?.url
    return (
        <div className="flex items-center justify-end gap-1">
            <div
                className={`flex h-[22px] w-[32px] items-center justify-center rounded-sm bg-giphyCharcoal ${
                    !prevUrl ? 'pointer-events-none bg-giphyCharcoal/30' : 'cursor-pointer'
                }`}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (prevUrl) {
                        router.push(relativeUrl(prevUrl))
                    }
                }}
            >
                <NavigateLeftIcon height={13} />
            </div>
            <div
                className={`flex h-[22px] w-[32px] items-center justify-center rounded-sm bg-giphyCharcoal ${
                    !nextUrl ? 'pointer-events-none bg-giphyCharcoal/30' : 'cursor-pointer'
                }`}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (nextUrl) {
                        router.push(relativeUrl(nextUrl))
                    }
                }}
            >
                <NavigateRightIcon height={13} />
            </div>
        </div>
    )
}
export default DesktopPagination
